import { Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";

type DetailRowProps = {
  label: string;
  value: string;
  isPrimary: boolean;
};

export const DetailRow = ({ label, value, isPrimary }: DetailRowProps) => (
  <div className="mobius-product-summary__detail-row">
    <Text
      elementType="span"
      className={classNames("mobius-product-summary__detail-text", {
        "mobius-product-summary__detail-text--primary": isPrimary,
      })}
    >
      {label}
    </Text>
    <Text
      elementType="span"
      className={classNames(
        "mobius-product-summary__detail-text",
        "mobius-product-summary__detail-value",
        { "mobius-product-summary__detail-text--primary": isPrimary },
      )}
    >
      {value}
    </Text>
  </div>
);

DetailRow.displayName = "DetailRow";
